import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ISalonsSearchResults } from '@app/salons-search-results/models/salons-search-results.model';
import { ISeoTagType } from '@app/shared/services/seo/seo-tag-type.enum';
import { SEOService } from '@app/shared/services/seo/seo.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-salons-search-results',
  templateUrl: './salons-search-results.component.html',
  styleUrls: ['./salons-search-results.component.scss']
})
export class SalonsSearchResultsComponent implements OnInit, OnDestroy {
  searchResults: ISalonsSearchResults;
  formattedPageTitle = '';
  private masterSubscription = new Subscription();

  constructor(
    private seoService: SEOService,
    private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.searchResults = this.route.snapshot.data.salonSearchResults;
    this.formattedPageTitle = this.getFormattedPageTitle();
    this.setVaryingSEO();
  }

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
  }

  private getFormattedPageTitle(): string {
    const cityName = this.searchResults.cityName;
    const department = this.searchResults.department;
    if (department) {
      return `${cityName}, ${department.name}`;
    }
    return cityName;
  }

  private setVaryingSEO(): void {
    const sub = this.route.paramMap
      .subscribe((paramMap: ParamMap) => {
        const params = {
          cityName: paramMap.get('cityName'),
          departmentName: paramMap.get('departmentName')
        };
        if (params.departmentName) {
          this.seoService.setSEO([
            {
              tagType: ISeoTagType.Title,
              i18nKey: 'SALON-SEARCH-RESULTS.META-SCENARIOS.CITY-AND-DEPARTMENT.META-TITLE',
              i18nParams: params
            },
            {
              tagType: ISeoTagType.Description,
              i18nKey: 'SALON-SEARCH-RESULTS.META-SCENARIOS.CITY-AND-DEPARTMENT.META-DESCRIPTION',
              i18nParams: params
            }
          ]);
          return;
        }
        this.seoService.setSEO([
          {
            tagType: ISeoTagType.Title,
            i18nKey: 'SALON-SEARCH-RESULTS.META-SCENARIOS.ONLY-CITY.META-TITLE',
            i18nParams: params
          },
          {
            tagType: ISeoTagType.Description,
            i18nKey: 'SALON-SEARCH-RESULTS.META-SCENARIOS.ONLY-CITY.META-DESCRIPTION',
            i18nParams: params
          }
        ]);
      });
    this.masterSubscription.add(sub);
  }

}
